import React from 'react';
import PropTypes from 'prop-types';
import styles from './css/Icon.module.scss';

const Icon = props => {
	let classesToApply = [props.className, styles.svg];
	if (props.internal) {
		classesToApply.push(styles.internal);
	}
	if (!props.noFlip) {
		classesToApply.push(styles.flipIcon);
	}

	return (
		<svg
			className={classesToApply.join(' ')}
			style={{...props.styles}}
			xmlns="http://www.w3.org/2000/svg"
			width={`${props.size}px`}
			height={`${props.size}px`}
			viewBox="0 0 512 512"
		>
			<g transform={props.transform}>
				<path className={props.colorClass} style={styles.path} d={props.icon} />
			</g>
		</svg>
	);
};

Icon.propTypes = {
	icon: PropTypes.string.isRequired,
	size: PropTypes.string,
	colorClass: PropTypes.string.isRequired
};

Icon.defaultProps = {
	size: '34'
};

export default Icon;
